import audit from "@/assets/reconciliation-automate/features/freya-audit.png"
import histori from "@/assets/reconciliation-automate/features/freya-histori.png"
import erp from "@/assets/reconciliation-automate/features/freya-integrasi.png"
import Image from "next/image"

export const featuresRecon = [
  {
    title : "recon_feature_list_title_1",
    image: null
  },
  {
    title : "recon_feature_list_title_2",
    image : () => {
      return (
        <Image src={audit} />
      )
    }
  },
  {
    title : "recon_feature_list_title_3",
    image : () => {
      return (
        <Image src={erp} />
      )
    }
  },
  {
    title : "recon_feature_list_title_4",
    image : () => {
      return (
        <Image src={histori} />
      )
    }
  },
]